import Alpine from "alpinejs";
import htmx from "htmx.org";
import { DEBOUNCE_CONTENT_SCROLL_TOP_MS } from "../timing";

const contentScrollTop: Alpine.DirectiveCallback = (el, _, { cleanup }) => {
  const parent = el.parentElement;
  if (parent == null) return;

  let height = 0;

  const mutationObs = new MutationObserver(() => {
    if (height === 0) return;

    const newHeight = parent.scrollHeight;
    const delta = newHeight - height;

    if (delta > 0) {
      parent.scrollTop += delta;
      mutationObs.disconnect();
      el.remove();
    }
  });

  let debounceTimer: ReturnType<typeof setTimeout> | null = null;

  const intersectionObs = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          if (debounceTimer != null) continue;

          debounceTimer = setTimeout(() => {
            height = parent.scrollHeight;
            htmx.trigger(el, "fire", {});
            intersectionObs.disconnect();

            mutationObs.observe(parent, {
              childList: true,
              subtree: true,
            });
          }, DEBOUNCE_CONTENT_SCROLL_TOP_MS);
        } else if (debounceTimer != null) {
          clearTimeout(debounceTimer);
          debounceTimer = null;
        }
      }
    },
    { root: parent, threshold: 0 },
  );

  intersectionObs.observe(el);

  cleanup(() => {
    if (debounceTimer != null) clearTimeout(debounceTimer);
    htmx.trigger(el, "htmx:abort", {});
    intersectionObs.disconnect();
    mutationObs.disconnect();
  });
};
export default contentScrollTop;
